import mixpanel from 'mixpanel-browser'
import { serverEnvironment } from 'env'
import { handleAPI, API_VERSION_TWO } from './apiUtils'
import store from '../redux/store'

let isInit = false
const getInitState = (): boolean => {
  return isInit
}

const setInitState = (): void => {
  isInit = true
}

const createString = (prefix: string, id: string): string => {
  const totalLength = 5
  const combined = `${prefix}${id}`
  const numZeros: number = totalLength - combined.length
  const zeros: string = '0'.repeat(Math.max(0, numZeros))

  return `${prefix}${zeros}${id}`
}

export const mixPanelBEevent = async <T extends Record<string, unknown>>(data: {
  event_name: string
  properties?: T
}): Promise<void> => {
  try {
    const url = `/${API_VERSION_TWO}/events`
    const method = 'POST'
    await handleAPI(url, {}, method, data)
  } catch (e) {
    console.log('mixpanel error', e)
  }
}
export const initMixpanel = (): void => {
  const { auth, organization } = store.getState()
  const isOnboarding = !!organization.organization.metadata.first_admin_details.first_admin_token
  const ID_PREFIX = { aws: 1, oci: 2, staging: 3, default: 4 }
  const orgId = auth?.employee?.organization?.id.toString() ?? ''
  // Register super properties: These properties will be sent with every event
  // CAUTION: Calling mixpanel.register elsewhere will overwrite existing super properties.
  const superProperties = {
    org_id: createString(ID_PREFIX[serverEnvironment ?? 'default'], orgId),
    // ... add more properties as needed
  }
  // ? Use mixpanel events
  if (
    import.meta.env.REACT_APP_MIXPANEL &&
    ['aws', 'oci', 'staging'].includes(serverEnvironment || '') &&
    !isOnboarding
  ) {
    mixpanel.init(import.meta.env.REACT_APP_MIXPANEL)
    const id = auth?.employee?.id?.toString() ?? ''
    const identity = createString(ID_PREFIX[serverEnvironment ?? 'default'], id)
    mixpanel.identify(identity)
    mixpanel.register(superProperties)
    setInitState()
  }
}

export const mixPanelAnalytics = <T extends Record<string, unknown>>(data: {
  event_name: string
  properties?: T
}): void => {
  const { organization } = store.getState()
  const isOnboarding = !!organization.organization.metadata.first_admin_details.first_admin_token

  if (
    import.meta.env.REACT_APP_MIXPANEL &&
    ['aws', 'oci', 'staging'].includes(serverEnvironment || '') &&
    !isOnboarding &&
    getInitState()
  ) {
    mixpanel.track(data.event_name, data.properties)
  }
}

// Function to convert the string case to human readable case
export const humanize = (str: string): string => {
  return str
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, (m) => {
      return m.toUpperCase()
    })
}
